import { render } from "./team-management.view.vue?vue&type=template&id=1a5cb1ca&scoped=true&ts=true"
import script from "./team-management.view.vue?vue&type=script&lang=ts"
export * from "./team-management.view.vue?vue&type=script&lang=ts"

import "./team-management.view.vue?vue&type=style&index=0&id=1a5cb1ca&lang=scss&scoped=true"
import "./team-management.view.vue?vue&type=style&index=1&id=1a5cb1ca&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a5cb1ca"]])

export default __exports__